module.exports = __webpack_public_path__ + "92b09642207b5020a0c09e8b200a00e4.svg";